var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70833 10H2.29167C1.68408 9.99934 1.10157 9.75768 0.671944 9.32806C0.242317 8.89843 0.000661737 8.31592 0 7.70833L0 2.29167C0.000661737 1.68408 0.242317 1.10157 0.671944 0.671944C1.10157 0.242317 1.68408 0.000661737 2.29167 0L7.70833 0C8.31592 0.000661737 8.89843 0.242317 9.32806 0.671944C9.75768 1.10157 9.99934 1.68408 10 2.29167V7.70833C9.99934 8.31592 9.75768 8.89843 9.32806 9.32806C8.89843 9.75768 8.31592 9.99934 7.70833 10ZM2.29167 1.25C2.0154 1.25 1.75045 1.35975 1.5551 1.5551C1.35975 1.75045 1.25 2.0154 1.25 2.29167V7.70833C1.25 7.9846 1.35975 8.24955 1.5551 8.4449C1.75045 8.64025 2.0154 8.75 2.29167 8.75H7.70833C7.9846 8.75 8.24955 8.64025 8.4449 8.4449C8.64025 8.24955 8.75 7.9846 8.75 7.70833V2.29167C8.75 2.0154 8.64025 1.75045 8.4449 1.5551C8.24955 1.35975 7.9846 1.25 7.70833 1.25H2.29167ZM3.33 3.89125V6.10875C3.33 6.20631 3.35563 6.30217 3.40431 6.38671C3.45299 6.47126 3.52303 6.54154 3.6074 6.59053C3.69178 6.63951 3.78754 6.66547 3.8851 6.66582C3.98267 6.66616 4.07861 6.64088 4.16333 6.5925L6.38292 5.48375C6.46822 5.43503 6.53912 5.36463 6.58844 5.27967C6.63775 5.19472 6.66372 5.09823 6.66372 5C6.66372 4.90177 6.63775 4.80528 6.58844 4.72033C6.53912 4.63537 6.46822 4.56497 6.38292 4.51625L4.16333 3.4075C4.07861 3.35912 3.98267 3.33384 3.8851 3.33418C3.78754 3.33453 3.69178 3.36049 3.6074 3.40947C3.52303 3.45846 3.45299 3.52874 3.40431 3.61329C3.35563 3.69783 3.33 3.79369 3.33 3.89125Z",
    fill: "#868E96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsInactive);
export default __webpack_public_path__ + "static/media/MeetingsInactive.8c26da1c4d88c860a9ac45ab99ea0778.svg";
export { ForwardRef as ReactComponent };